module.exports = __webpack_public_path__ + "static/centaur-1-bcf5140ea01d8389905c70fb0d748a37.jpg";